/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-globals */
import React, { useEffect, useMemo } from 'react';
import InputMask from 'react-input-mask';
import {
  Button,
  Checkbox,
  ClickAwayListener,
  Fab,
  Input,
  InputAdornment,
  InputBase,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { useSelector } from 'react-redux';
import { createTheme } from '@mui/material/styles';
import ThemeProvider from '@mui/system/ThemeProvider/ThemeProvider';
import { CalendarMonth } from '@mui/icons-material';
import MaskInput from './MaskInput';
import ProductMaskInput from './productCustomMask';
import { hasNonEmptyValue } from '../../utils';

type inputType = {
  inputPlaceholder?: string;
  size?: any;
  label: string;
  type?: any;
  maxLength?: number;
  placeholder?: string;
  isDisabled: boolean;
  name?: any;
  value?: any;
  onChange?: any;
  inputProps?: any;
  error?: boolean;
  helperText?: string;
  defaultValue?: string;
  numericValue?: boolean;
  phone?: boolean;
  timeType?: boolean;
  dateType?: boolean;
  mask?: any;
  maskChar?: any;
  key?: any;
  required?: boolean;
  validate?: string;
  val?: any;
  attr?: any;
  style?: any;
  labelStyle?: any;
  inputStyle?: any;
  noAwayListener?: boolean;
  isNumber?: boolean;
  margin?: any;
  isBatch?: any;
  datagrid?: boolean;
  isParentSetOfDatagridField?: boolean;
};
const months:any = [
  'January',
  'february',
  'March',
  'April',
  'May',
  'Jun',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
const CustomInput = (props: inputType) => {
  const {
    inputPlaceholder,
    size,
    margin,
    label,
    placeholder,
    isDisabled,
    type,
    isBatch,
    maxLength,
    name,
    value,
    onChange,
    inputProps,
    error,
    helperText,
    required,
    defaultValue,
    numericValue,
    phone,
    timeType,
    dateType,
    attr,
    mask,
    maskChar,
    key,
    validate,
    val,
    style,
    labelStyle,
    inputStyle,
    noAwayListener,
    isNumber,
    datagrid,
    isParentSetOfDatagridField,
  } = props;

  const [count, setCount] = React.useState(Number(value));
  const [valueDate, setValueDate] = React.useState<Date | null>(null);
  const [open, setOpen] = React.useState(false);
  const [inFocus, setInFocus] = React.useState(false);
  const [checked, setChecked] = React.useState(false);
  const [isElementChecked, setIsElementChecked] = React.useState(false);
  const [localChangesMade, setlocalChangesMade] = React.useState(undefined);
  const [isValidEmail, setIsValidEmail] = React.useState(true);
  const [datePickerOpen, setDatePickerOpen] = React.useState(false);
  const [pickerDate, setPickerDate] = React.useState(() => {
    if (value) {
      const dateFormatted = `${value?.toString()?.slice(2, 4)}/${value?.toString()?.slice(
        4,
        6,
      )}/20${value?.toString()?.slice(0, 2)}`;
      return new Date(dateFormatted);
    }
    return new Date();
  });
  const [dateAnchorEl, setDateAnchorEl] = React.useState<null | HTMLElement>(
    null,
  );

  useEffect(() => {
    if (dateType && value) {
      const dateFormatted = `${value.toString().slice(2, 4)}/${value.slice(
        4,
        6,
      )}/20${value?.toString().slice(0, 2)}`;
      setPickerDate(new Date(dateFormatted));
    }
  }, [value]);
  // eslint-disable-next-line max-len
  const handleDateInputClick = (event: React.MouseEvent<HTMLInputElement>) => {
    setDateAnchorEl(event.currentTarget);
    // setDatePickerOpen(true);
  };

  const handleOpenDatePicker = () => {
    setDatePickerOpen(true);
  };

  const handleCloseDatePicker = () => {
    setDateAnchorEl(null);
  };

  const handleLocalChanges = (e: any, existingValue: any) => {
    console.log(
      `handleLocalChanges: \n target name: ${e.target.name} \n existing value: ${existingValue}`,
    );
    if (e.target.value !== (null || undefined) && e.target.value !== value) {
      setlocalChangesMade(e);
      setIsElementChecked(true);

      if (isBatch === 'Batch') {
        onChange(
          isElementChecked
            ? localChangesMade
            : { target: { name, value: undefined } },
        );
      }
    }
  };

  const enableDisableLocalChanges = () => {
    setIsElementChecked(!isElementChecked);

    if (isBatch === 'Batch') {
      if (localChangesMade !== undefined) {
        onChange(
          !isElementChecked
            ? localChangesMade
            : { target: { name, value: undefined } },
        );
      } else if (localChangesMade === undefined) {
        onChange({
          target: { name, value: !isElementChecked ? 'null' : undefined },
        });
      }
    }
  };

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    if (required || !isValidEmail) {
      setOpen(true);
    }
  };

  const add = () => {
    onChange({
      target: {
        name,
        value: Number(value) + 1,
      },
    });
  };
  const { activeScreen } = useSelector((state: any) => state.ScreenReducer);
  // console.log(`name: ${JSON.stringify(name)}`);
  // console.log(`value: ${JSON.stringify(value)}`);
  const subtract = () => {
    Number(value) > 0
    && onChange({
      target: {
        name,
        value: Number(value) - 1,
      },
    });
  };

  const [InputSize, setInputSize] = React.useState('');
  const handleBlur = () => {
    setInFocus(false);

    if (name === 'loads_per_sample') {
      onChange({
        target: {
          value: isNaN(value) ? '' : value.toString().padStart(4, '0'),
          name,
        },
      });
      return;
    }

    if (
      validate === 'numzf'
      && !attr?.includes('noneg')
      && !name?.includes('adjustment')
      && !attr?.includes('alphanum')
      && !name?.includes('weight')
      && !attr
    ) {
      onChange({
        target: {
          value: !isNaN(value)
            ? value
            : ''.padStart(inputProps?.maxLength || 0, '0'),
          name,
        },
      });
    } else if (validate === 'anumzf' && !attr?.includes('alphanum')) {
      // if not alphanum and value not empty, add zeros mask
      // if not alphanum and value is empty, keep an empty value
      onChange({
        target: {
          value: !isNaN(value)
            ? value !== ''
              ? String(value).padStart(inputProps?.maxLength || 0, '0')
              : value
            : value,
          name,
        },
      });
    } else if (validate === 'anumzf' && attr?.includes('alphanum')) {
      // if alphanum but value has only numeric chars, add zeros mask
      onChange({
        target: {
          value: !isNaN(value) && value !== ''
            ? String(value).padStart(inputProps?.maxLength || 0, '0')
            : value,
          name,
        },
      });
    } else if (validate === 'anumzfspace' && attr?.includes('alphanumspace')) {
      // if alphanumspace and value is numeric, add zeros mask
      // if alphanumspace and value is alphanumeric, add space mask
      onChange({
        target: {
          value: !isNaN(value)
            ? value !== ''
              ? String(value).padStart(inputProps?.maxLength || 0, '0')
              : value
            : value !== ''
              ? String(value).padEnd(inputProps?.maxLength || 0, ' ')
              : value,
          name,
        },
      });
    }

    // Validate
    if (attr?.includes('email')) {
      // \. is needed on regex to present dot else it means anything
      // eslint-disable-next-line
      const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      if (value === '' || value.match(mailformat)) {
        setIsValidEmail(true);
      } else {
        setIsValidEmail(false);
      }
    }
  };

  const validationTooltipTitle = () => (validate?.includes('numzf') && required
    ? 'This field is required\n can not be negative'
    : !isValidEmail
      ? 'Must be e-mail format'
      : 'This field is required');

  const backgroundColor = useMemo(() => {
    if (val && !val.visible) {
      return '#fff9f0';
    }
    if (isDisabled) {
      return '#f8f8f8';
    }
    return '#fff';
  }, [value, isDisabled, val]);

  React.useEffect(() => {
    if (value !== null) {
      setChecked(true);
    }
  }, [value]);

  return (
    <div
      style={
        style || {
          width: '100%',
          alignSelf: 'center',
          marginTop: margin !== '0px' ? '5px' : '0px',
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          justifyContent: 'flex-end',
        }
      }
    >
      <div
        style={{
          flex: !datagrid ? 1 : 'none',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'right',
        }}
      >
        {!datagrid && (
        <Typography
          className="f12"
          style={{ flex: 1, textAlign: 'right', ...(labelStyle || null) }}
        >
          {label}
        </Typography>
        )}
        {!['grid'].includes(type)
        && required === false
        && isBatch === 'Batch' && (
          <Checkbox
            checked={isElementChecked}
            onClick={() => enableDisableLocalChanges()}
          />
        )}
      </div>
      {(() => {
        if (timeType) {
          return (
            <div
              style={
                margin !== '0px'
                  ? { flexWrap: 'nowrap', display: 'flex', flex: 3 }
                  : {
                    // width: '100%',
                    marginTop: datagrid ? '0px' : '10px',
                    display: 'flex',
                    gap: 10,
                    flex: 3,
                  }
              }
            >
              <TextField
                className="textfield"
                name={name}
                inputProps={{ step: 1 }}
                value={value && `${value.slice(0, 2)}:${value.slice(2, 4)}`}
                defaultValue={value}
                onChange={(e: any) => {
                  if (isBatch === 'Batch') {
                    setIsElementChecked(true);
                  }
                  onChange({
                    target: {
                      name,
                      value: `${e.target.value.slice(
                        0,
                        2,
                      )}${e.target.value.slice(3, 5)}`,
                    },
                  });
                }}
                placeholder={placeholder}
                size="small"
                color={required && value === '' ? 'error' : 'primary'}
                type={type}
                style={{
                  color: '#f7f7f7',
                }}
                disabled={isDisabled}
                sx={{
                  '& .css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input': {
                    padding: '2px 8px',
                    border: '1px solid #E4E4E4',
                  },
                  '& .MuiInputBase-root': {
                    '& > fieldset': {
                      borderColor:
                        required && value === '' ? 'error' : 'primary',
                      borderLeft: '5px solid #555',
                      borderRadius: '0px !important',
                    },
                    '&::before': {
                      content: `'${value?.slice(0, 2)}:${value?.slice(2, 4) || placeholder}'`,
                      position: 'absolute',
                      backgroundColor: '#fff',
                      fontSize: '10px',
                      paddingLeft: '10px',
                      width: '99%',
                    },
                    '&::after': {
                      width: 0,
                      content: '""',
                    },
                  },

                  width: size,
                  '& input[type="time"]::-webkit-calendar-picker-indicator': {
                    display: 'inlineBlock',
                    background: isDisabled ? '#f8f8f8' : 'transparent',
                    // border: required ? '1px solid red' : 'transparent',
                    bottom: 0,
                    color: 'transparent',
                    cursor: 'pointer',
                    height: 'auto',
                    left: 0,
                    position: 'absolute',
                    right: 0,
                    top: 0,
                    width: size,
                  },
                }}
                // error={error}
                // helperText={name}
              />
            </div>
          );
        }
        if (dateType) {
          return (
            <div
              style={
                margin !== '0px'
                  ? {
                    flexWrap: 'nowrap', display: 'flex', flex: 3,
                  }
                  : {
                    // width: '100%',
                    marginTop: datagrid ? '0px' : '10px',
                    display: 'flex',
                    gap: 10,
                    flex: 2,
                  }
              }
            >
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                {!isDisabled && (
                <DatePicker
                  label="Custom input"
                  PopperProps={{ anchorEl: dateAnchorEl }}
                  onOpen={() => setDatePickerOpen(true)}
                  onClose={() => setDatePickerOpen(false)}
                  value={pickerDate}
                  readOnly={isDisabled}
                  open={datePickerOpen}
                  onChange={(newValue:any) => {
                    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
                    const newValueFormatted = newValue?.toLocaleDateString('pt-BR', options);
                    onChange({
                      target: {
                        name,
                        value: `${newValueFormatted?.slice(
                          8,
                        )}${newValueFormatted?.slice(3, 5)}${newValueFormatted?.slice(
                          0,
                          2,
                        )}`,
                      },
                    });
                  }}
                  renderInput={() => <></>}
                />
                )}
                <TextField
                  onClick={handleDateInputClick}
                  className="textfield"
                  name={name}
                  value={
                    value && activeScreen.screenId === 'MAINT-164'
                      ? `${months?.[Number(value.slice(2, 4)) - 1]}-${value.slice(
                        4,
                        6,
                      )} ` : value && activeScreen.screenId !== 'MAINT-164' ? `${value.slice(2, 4)}/${value.slice(
                        4,
                        6,
                      )}/20${value.slice(0, 2)}` : ''
                  }
                  defaultValue={defaultValue}
                  onChange={(e: any) => {
                    onChange({
                      target: {
                        name,
                        value: `${e.target.value.slice(
                          8,
                          10,
                        )}${e.target.value.slice(0, 2)}${e.target.value.slice(
                          3,
                          5,
                        )}`,
                      },
                    });
                  }}
                  placeholder={placeholder || label}
                  size="small"
                  // type={type}
                  style={{
                    color: '#f7f7f7',
                    borderRadius: '0px !important',
                  }}
                  color={required && value === '' ? 'error' : 'primary'}
                  disabled={isDisabled}
                  sx={{
                    '& .css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input': {
                      padding: '4px 8px',
                      border: '1px solid #E4E4E4',
                    },
                    width: '98.5%',
                    borderLeft: '5px solid #555',
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '0px !important',
                    },
                    borderRadius: '0px !important',
                    '& input[type="date"]::-webkit-calendar-picker-indicator': {
                      display: 'inlineBlock',
                      background: isDisabled ? '#f8f8f8' : 'transparent',
                      '& .MuiInputBase-root': {
                        borderRadius: '0px !important',
                        '& > fieldset': {
                          borderColor:
                            required && value === '' ? 'error' : 'transparent',
                        },
                      },
                      bottom: 0,
                      color: 'transparent',
                      cursor: 'pointer',
                      height: 'auto',
                      left: 0,
                      position: 'absolute',
                      borderLeft: '5px solid #555',
                      right: 0,
                      top: 0,
                      width: size,
                    },
                    '& input[type="date"]:disabled': {
                      borderLeft: '5px solid #555',
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <CalendarMonth
                          onClick={() => setDatePickerOpen(true)}
                          style={{ cursor: 'pointer' }}
                        />
                      </InputAdornment>
                    ),
                  }}
                />
                {/* <InputBase value="slkdlmsqdklsqmkdms" onClick={handleDateInputClick} /> */}
              </LocalizationProvider>
            </div>
          );
        }
        if (numericValue) {
          return (
            <ClickAwayListener onClickAway={handleTooltipClose}>
              <div style={{ flexWrap: 'nowrap', display: 'flex', flex: 3 }}>
                <Tooltip
                  PopperProps={{
                    disablePortal: true,
                  }}
                  placement="top"
                  arrow
                  color="red"
                  onClose={handleTooltipClose}
                  open={open}
                  disableFocusListener
                  disableHoverListener
                  disableTouchListener
                  title="Add"
                >
                  <TextField
                    className="textfield"
                    name={name}
                    value={
                      count || value
                    }
                    defaultValue={defaultValue}
                    onChange={(e:any) => {
                      onChange({
                        target: {
                          name,
                          value: e.target.value,
                        },
                      });
                    }}
                    placeholder={placeholder}
                    size="small"
                    type="text"
                    inputProps={inputProps}
                    style={{
                      color: '#f7f7f7',
                      background: isDisabled ? '#f8f8f8' : 'transparent',
                      // border: required ? '1px solid red' : 'transparent',
                    }}
                    color={required && value === '' ? 'error' : 'primary'}
                    // eslint-disable-next-line react/jsx-no-duplicate-props
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Button variant="outlined" size="small" color="inherit" sx={{ height: 23, width: 10 }} onClick={subtract}>
                            <RemoveIcon sx={{ color: '#000' }} />
                          </Button>
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <Button variant="outlined" size="small" color="inherit" sx={{ height: 23, width: 10 }} onClick={add}>
                            <AddIcon sx={{ color: '#000' }} />
                          </Button>
                        </InputAdornment>
                      ),
                    }}
                    disabled={isDisabled}
                    sx={{
                      '& .css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input': {
                        padding: '4px 8px',
                        border: '1px solid #E4E4E4',
                      },
                      width: size,
                      '& .MuiInputBase-root': {
                        '& > fieldset': {
                          borderColor:
                            required && value === '' ? 'red' : '#e8e8e8',
                        },
                      },
                      borderLeft: '5px solid #555',
                    }}
                    error={error}
                    // helperText={name}
                  />
                </Tooltip>
              </div>
            </ClickAwayListener>
          );
        }
        if (phone && name?.search('comp_pct') === -1 && name !== 'pct_oxygen' && name !== 'octane') {
          return (
            <MaskInput
              value={value}
              onChange={onChange}
              size={size}
              mask={mask}
              isMaskValueFractional={mask?.includes('.') === true}
              maskPlaceholder={inputPlaceholder}
              name={name}
              isParentSetOfDatagridField={isParentSetOfDatagridField}
            />
          );
        }
        if ((phone && name?.search('comp_pct') > -1) || name === 'pct_oxygen' || name === 'octane') {
          return (
            <ClickAwayListener onClickAway={handleTooltipClose}>
              <div
                key={key}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  width: !noAwayListener ? size : 'none',
                  flex: 3,
                }}
              >
                <Tooltip
                  PopperProps={{
                    disablePortal: true,
                    color: 'red',
                  }}
                  onClose={handleTooltipClose}
                  open={open}
                  placement="top"
                  arrow
                  color="red"
                  disableFocusListener={false}
                  disableHoverListener={false}
                  disableTouchListener={false}
                  title={'Cannot be negative,\nPercentage missing'}
                >
                  <ProductMaskInput
                    value={value}
                    onChange={onChange}
                    size={size}
                    mask={mask}
                    maxLength={maxLength}
                    isMaskValueFractional={mask?.includes('.') === true}
                    maskPlaceholder={inputPlaceholder}
                    name={name}
                    onClick={() => setOpen((isParentSetOfDatagridField && !hasNonEmptyValue(value)) as boolean ?? false)}
                    onFocus={() => setInFocus(true)}
                    onUnfocus={setInFocus}
                    isParentSetOfDatagridField={
                      isParentSetOfDatagridField && !hasNonEmptyValue(value)
                    }
                  />

                </Tooltip>
                {inFocus && mask?.length > 0 && (
                <Typography
                  style={{
                    position: 'absolute',
                    right: 38,
                    fontSize: 12,
                    color: mask?.length === value?.length ? 'red' : 'gray',
                    zIndex: 2,
                  }}
                >
                  {`${value?.length ?? 0} / ${mask?.length}`}
                </Typography>
                )}
              </div>
            </ClickAwayListener>
          );
        }
        return (
          <ClickAwayListener onClickAway={handleTooltipClose}>
            <div
              key={key}
              style={{
                display: 'flex',
                alignItems: 'center',
                width: !noAwayListener ? size : 'none',
                flex: 3,
              }}
            >
              <Tooltip
                PopperProps={{
                  disablePortal: true,
                  color: 'red',
                }}
                onClose={handleTooltipClose}
                open={open}
                placement="top"
                arrow
                color="red"
                disableFocusListener
                disableHoverListener
                disableTouchListener
                title={validationTooltipTitle()}
              >
                <TextField
                  className="textfield"
                  name={name}
                  value={value === 'null' || value === null ? '' : value}
                  defaultValue={defaultValue}
                  onChange={(e: any) => {
                    if (isBatch === 'Batch') {
                      handleLocalChanges(e, value);
                      onChange(e);
                    } else {
                      onChange(e);
                    }
                    setInputSize(e.target.value);
                  }}
                  onFocus={() => setInFocus(true)}
                  onBlur={handleBlur}
                  placeholder={placeholder}
                  size="small"
                  onClick={handleTooltipOpen}
                  type={
                    isNumber || attr?.includes('num')
                      ? 'text'
                      : attr?.includes('secure')
                        ? 'password'
                        : 'type'
                  }
                  inputProps={inputProps}
                  disabled={isDisabled}
                  sx={{
                    '& .css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input': {
                      padding: '4px 8px',
                      border: '1px solid transparant',
                    },
                    '& .MuiInputBase-root': {
                      '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button':
                        {
                          display:
                            isNumber || attr?.includes('num')
                              ? 'none'
                              : 'inline',
                        },
                      '& input[type=number]': {
                        MozAppearance:
                          isNumber || attr?.includes('num')
                            ? 'textfield'
                            : 'none',
                      },
                      '& > fieldset': {
                        borderColor:
                          (validate?.includes('anumzf')
                            && !attr?.includes('alphanum')
                            && isNaN(value)
                            && required)
                          || (required && value === '')
                          || !isValidEmail
                            ? 'red'
                            : 'gray',
                        borderLeft: required
                          ? '5px solid red'
                          : '5px solid #555',
                        borderRadius: '0px !important',
                      },
                    },
                    '& .MuiInputBase-root.Mui-disabled': {
                      '& > fieldset': {
                        borderColor:
                          (required && value === '') || !isValidEmail
                            ? 'red'
                            : 'transparent',
                        borderLeft: required
                          ? '5px solid red'
                          : '5px solid #555',
                        borderRadius: '0px !important',
                        // backgroundColor: '#f8f8f8',
                        color: '#000',
                      },
                    },
                    width: size,
                    background: backgroundColor,
                    // borderLeft: '5px #000 solid',
                  }}
                  error={
                    attr?.includes('noneg') && isNaN(value) && value !== ''
                  }
                  color={
                    (required && value === '') || !isValidEmail
                      ? 'error'
                      : 'primary'
                  }
                  helperText={
                    attr?.includes('noneg') && isNaN(value) && value !== ''
                      ? 'can not be negative, must be numeric'
                      : null
                  }
                />
              </Tooltip>
              {inFocus && inputProps?.maxLength > 0 && value?.length > 0 && (
                <Typography
                  style={{
                    marginLeft: -48,
                    fontSize: 12,
                    color: 'gray',
                    zIndex: 2,
                  }}
                >
                  {`${value?.length} / ${inputProps?.maxLength}`}
                </Typography>
              )}
            </div>
          </ClickAwayListener>
        );
      })()}
    </div>
  );
};
CustomInput.defaultProps = {
  name: null,
  value: null,
  type: null,
  inputProps: {},
  maxLength: null,
  size: null,
  error: false,
  helperText: null,
  defaultValue: null,
  numericValue: false,
  phone: false,
  timeType: false,
  dateType: false,
  placeholder: null,
  mask: null,
  maskChar: null,
  key: null,
  attr: null,
  required: false,
  validate: '',
  val: null,
  style: null,
  labelStyle: null,
  isBatch: undefined,
  inputStyle: null,
  noAwayListener: false,
  inputPlaceholder: null,
  onChange: onchange,
  isNumber: false,
  margin: null,
  datagrid: false,
  isParentSetOfDatagridField: false,
};
export default CustomInput;
